module.exports = __webpack_public_path__ + "assets/images/cronicos.aed84e60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kits/cronicos.png
// module id = 821
// module chunks = 1